import {Component, inject, Input} from '@angular/core';
import {Button} from 'primeng/button';
import {MailboxConfiguratorFacade} from '../../../mailbox-configurator.facade';
import {InboundFormComponent} from '../../shared/inbound-form.component';
import {FormGroup} from '@angular/forms';

@Component({
	selector: 'app-inbound-step',
	standalone: true,
	template: `
		<div class="w-full flex flex-column gap-4">
			<app-inbound-form [form]="form" />

			<div class="flex justify-content-end gap-2">
				<p-button (onClick)="facade.next()"
						  [disabled]="form.invalid"
						  variant="outlined"
						  severity="success">Avanti</p-button>
			</div>
		</div>
	`,
	imports: [
		Button,
		InboundFormComponent
	],
	styles: ``
})
export class InboundStepComponent {
	protected facade = inject(MailboxConfiguratorFacade)

	@Input({ required: true }) form!: FormGroup;
}
